import { lookupRedirectActionRoute } from '@townsquare/routes/lookup-redirect-action';

import { LookupRedirectAction } from './loadable';
import { lookupActionProjectResource, lookupActionGoalResource } from './resource';

lookupRedirectActionRoute.component = LookupRedirectAction;
lookupRedirectActionRoute.resources = [lookupActionProjectResource, lookupActionGoalResource];
export const lookupRedirectActionRouterRoute = lookupRedirectActionRoute;
